export default {
  'ulockme': 'ulockme',
  'login.welcome': 'Ulockme server login',
  'title.edit.user-level': 'Edit user profile',
  'title.create.user-level': 'Define new user profile',
  'title': {
    'controller-details': 'Controller details',
    'email-notification': 'E-mail notification',
    'create-prereg': 'Create preregistration',
    'edit-mobile': 'Edit mobile',
    'edit-prereg': 'Edit preregistration',
    'create-access-scheme': 'Create access group',
    'edit-access-scheme': 'Edit access group',
    'create-external-service': 'Setup external service',
    'system-parameters': 'System preferences',
    'restore-mobile-access': 'Transfer selected accesses',
    'custom-filters': 'Filter events',
    'events': 'Events',
    'edit-switch': 'Edit switch',
    'switches': 'List of switches',
    'controllers': 'List of controllers',
    'access-for': 'Manage access',
    'accesses-for': 'Manage access',
    'set-access': 'Setup permissions',
    'users': 'Server users',
    'user-levels': 'Users security profiles',
    'mobiles': 'Mobiles and ID cards',
    'preregistrations': ' Keycodes (preregistrations)',
    'mobile-groups': 'Mobile groups',
    'switch-groups': 'Switch groups',
    'locations': 'Locations',
    'owners': 'Owners',
    'organizations': 'Organizations',
    'next-schedule': 'Next-schedule',
    'pending-jobs': 'Pending-jobs',
    'access-schemes': 'Access profiles',
    'pending-accesses': 'Pending accesses',
    'external-services': 'External services',
    'edit': {
      'owner': 'Edit owner',
      'organization': 'Edit organization',
      'user': 'Edit user',
      'switch-group': 'Edit switch group',
      'mobile-group': 'Edit mobile group',
      'location': 'Edit location'
    },
    'create': {
      'owner': 'Create owner',
      'organization': 'Create organization',
      'user': 'Create user',
      'switch-group': 'Create switch group',
      'mobile-group': 'Create mobile group',
      'location': 'Create location'
    },
    'activate-controller': 'Activate controller',
    'set-acces': 'Set access',
    'add-licence': 'Add licence',
    'remove': 'Remove'
  },
  'switchMode': {
    'offline': 'Offline - controller auth',
    'online': 'Online - server auth',
    'anti-pb': 'Online - server auth with Antipassback',
    'learning': 'Learning - no auth'
  },
  'profile': {
    'toggle': 'Entries',
    'all': 'All events'
  },
  'label': {
    'show_distant_switches': 'Allow distant open',
    'has-pending-access': 'Access pending',
    'hasEmail': 'Set e-mail notification',
    'contact_refid': 'Contact note',
    'userLevelId': 'Security profile',
    'userLevel': 'BLE access level',
    'has-access': 'Set access',
    'key_type': 'Key type',
    'timeout': 'Max timeout',
    'maxTries': 'Max retries',
    'url': 'URL',
    'ifVersion': 'Interface version',
    'espVersion': 'Network module ver',
    'commitHash': 'Subversion tag',
    'version': 'Version',
    'subnetMask': 'Subnet mask',
    'manualDhcp': 'Static IP',
    'serverShortCode': 'Server Code',
    'serverPort': 'Server port',
    'serverHost': 'Server hostname',
    'securityType': 'Security mode',
    'interval': 'Interval',
    'bytes': 'Command bytes',
    'topic': 'MQTT topic',
    'txPower': 'Bluetooth TX power',
    'restoreMobileId': 'Transfer accesses to (destination)',
    'profile': 'Selected events',
    'start_date': 'Start date',
    'ssid': 'SSID',
    'secuPassphrase': 'Security pass',
    'secuType': 'Security type',
    'serverIp': 'Server IP address',
    'customDhcp': 'User DHCP',
    'direction': 'Direction',
    'switch_id': 'Binding switch',
    'pausetime': 'Pause time',
    'autoclosetime': 'Switching time',
    'mode': 'Working mode',
    'email': 'Email',
    'password': 'Password',
    'name': 'Name',
    'street': 'Street',
    'zip': 'Zip',
    'city': 'City',
    'taxno': 'Tax number',
    'regno': 'Registration number',
    'contact_name': 'Contact name',
    'contact_phone': 'Contact phone',
    'contact_email': 'Contact email',
    'description': 'Description',
    'owner_id': 'Owner',
    'first_name': 'First name',
    'last_name': 'Last name',
    'phone': 'Phone',
    'user_level_id': 'User level',
    'organization_id': 'organization',
    'type': 'Type',
    'x_pos': 'X coordinate',
    'y_pos': 'Y coordinate',
    'z_pos': 'Z coordinate',
    'input_type': 'Input type',
    'pauseTime': 'Pause time',
    'autoCloseTime': 'Autoclose time',
    'keyType': 'Key type',
    'startDate': 'From',
    'endDate': 'To',
    'daily-duration': 'Duration',
    'days': 'Days',
    'systemTime': 'Server time',
    'events': 'Events',
    'LAN-status': 'LAN status',
    'switch-controll': 'Switchgroups and switch controll',
    'emergency-functions': 'Emergency functions',
    'event-statistics': 'Event statistics',
    'ipAddress': 'IP Address',
    'hostName': 'Hostname',
    'gatewayIp': 'Gateway IP',
    'isGatewayAlive': 'Gateway health',
    'serverLocation': 'Server location',
    'emergencyControll': 'Emergency controll',
    'mobileId': 'Mobile',
    'eventTypeId': 'Event type',
    'dateFrom': 'Starting date',
    'dateTo': 'Ending date',
    'size': 'Total results',
    'controllerIp': 'Manual IP Address',
    'gateway': 'Gateway',
    'subNetmask': 'Subnet mask',
    'ip': 'IP Address',
    'rssi': 'WiFi RSSI (dB)',
    'lastHeartbeat': 'Heartbeat time',
    'lastWifiReconnect': 'WiFi connected',
    'lastMqttReconnect': 'MQTT connected',
    'fqdn': 'Hostname (FQDN)',
    'location_id': 'Location',
    'license': 'License',
    'usage': 'Function'
  },
  'button': {
    'add-new': 'Add new',
    'login': 'Login',
    'submit': 'Submit',
    'new': 'Add new',
    'cancel': 'Cancel',
    'edit': 'Edit',
    'save': 'Save',
    'submit-scheduled': 'Add to scheduled list',
    'refresh': 'Refresh',
    'openAll': 'Open all',
    'normal': 'Normal',
    'disableAll': 'Disable all',
    'open': 'Open',
    'save-scheduled': 'Schedule save',
    'send': 'Save',
    'accept': 'Accept',
    'emergency': 'Emergency',
    'confirm': 'Confirm'
  },
  'operation': {
    'edit': 'Edit',
    'delete': 'Remove',
    'activate': 'Activate',
    'disable': 'Disable',
    'on': 'On',
    'off': 'Off',
    'toggle': 'Toggle',
    'disable-scheduled': 'Scheduled disable',
    'activate-scheduled': 'Scheduled activate',
    'delete-scheduled': 'Scheduled remove',
    'restore': 'Transfer',
    'single-access': 'Accesses'
  },
  'nav': {
    'home': 'Home',
    'owner-list': 'Owners',
    'organization-list': 'Organizations',
    'user-list': 'Users',
    'user-level-list': 'User profiles',
    'logout': 'Logout',
    'changeLanguage': 'Switch language',
    'administration': 'Administration',
    'devices': 'Devices',
    'server-details': 'Server',
    'controller-list': 'Controllers',
    'switch-list': 'Switches',
    'switch-group-list': 'Switch groups',
    'mobile-list': 'Mobiles and ID Cards',
    'mobile-group-list': 'Mobile groups',
    'location-list': 'Locations',
    'scheduled-jobs': 'Scheduled jobs',
    'monitoring': 'Monitoring',
    'event-list': 'Events',
    'event-list-entry': 'Entry events',
    'event-list-registration': 'Registrations',
    'event-list-system': 'System messages',
    'event-list-input': 'Sensor events',
    'preregistration-list': 'Keycodes - pregistrations',
    'pending-access-list': 'Pending accesses',
    'access-schemes-list': 'Accesses profiles',
    'external-service-list': 'External services',
    'system-parameter-list': 'System preferences'
  },
  'lang': {
    'hungarian': 'Hungarian',
    'english': 'English'
  },
  'secType': {
    'none': 'None',
    'WEP': 'WEP',
    'WPA': 'WPA-PSK',
    'WPA2': 'WPA2-PSK'
  },
  'header.mobile.contact_name': 'Mobile Contact',
  'header.switch.name': 'Switch name',
  'header': {
    'access-registration-status': 'Processing status',
    'status': 'Connection status',
    'rssi': 'WiFi RSSI',
    'ip': 'IP address',
    'mobileGroupName': 'Mobile group name',
    'switchGroupName': 'Switch group name',
    'controllerDescription': 'Description',
    'success': 'Acceptance',
    'controllerNames': 'Granted accesses',
    'userLevel': 'User level',
    'id': 'Id',
    'operations': 'Operations',
    'name': 'Name',
    'email': 'Email',
    'server_name': 'Server name',
    'controllerName': 'Controller',
    'state': 'Status',
    'contact_name': 'Contact name',
    'fqdn': 'FQDN',
    'param': 'Parameter',
    'userName': 'User',
    'first_name': 'First name',
    'last_name': 'Last name',
    'regcode': 'Keycode',
    'description': 'Description',
    'owner': 'Owner',
    'mobileName': 'Access name',
    'switchName': 'Switch name',
    'key_type': 'Key type',
    'type': 'Type',
    'url': 'Service URL',
    'attempts': 'Attempts',
    'occured': 'Date'
  },
  'tab': {
    'notifications': 'Notifications',
    'groups': 'Groups',
    'command': 'Test MQTT',
    'tx-power': 'BLE TX power',
    'inputs': 'Sensors',
    'details': 'Details',
    'serverAccesses': 'Server accesses',
    'controller-details': 'Name',
    'switches': 'Switches',
    'monitoring-settings': 'Monitoring setup',
    'settings': 'Settings',
    'controller-wifi-settings': 'WiFi setup',
    'in-progress-accesses': 'Processing..',
    'controller-diagnosis': 'Status',
    'readers': 'Reader setup'
  },
  'placeholder': {
    'mobile_group': 'Mobile group',
    'switch_group': 'Switch group',
    'owner_id': 'Select owner (type to filter)',
    'user_level_id': 'Select user level (type to filter)',
    'search': 'Search',
    'input_type': 'Select input type',
    'type': 'Select type',
    'select-a-date': 'Select a date',
    'select-days': 'Select the days',
    'selectComponent': 'Select a component',
    'mobileId': 'Select a mobile (optional)',
    'eventTypeId': 'Select an event type (optional)'
  },
  'related-organizations': 'Related organizations',
  'related-users': 'Related users',
  'related-mobiles': 'Related mobiles',
  'related-switches': 'Related switches',
  'related-servers': 'Related servers',
  'empty-table': 'No results',
  'tab.dashboard': 'Dashboard',
  'switch': 'Switch',
  'switch.entry-point': 'Entry point',
  'switch.hidden-system': 'Hidden system',
  'regStatus': {
    'none': 'Unassigned',
    'pending': 'Pending',
    'active': 'Active',
    'disabled': 'Disabled',
    'inprogress': 'Processing..'
  },
  'keyType': {
    'constant': 'Constant',
    'temporary': 'Temporary',
    'recurring': 'Recurring'
  },
  'switchType': {
    'gate': 'Gate',
    'garage': 'Garage',
    'switch': 'Switch',
    'light': 'Light'
  },
  'inputType': {
    'None': 'None',
    'Switch1Toggle': 'Switch #1 Toggle',
    'Switch2Toggle': 'Switch #2 Toggle',
    'Switch3Toggle': 'Switch #3 Toggle',
    'Switch4Toggle': 'Switch #4 Toggle',
    'Switch1On': 'Switch #1 On',
    'Switch2On': 'Switch #2 On',
    'Switch3On': 'Switch #3 On',
    'Switch4On': 'Switch #4 On',
    'AllSwitchOn': 'All Switch On',
    'Switch1Off': 'Switch #1 Off',
    'Switch2Off': 'Switch #2 Off',
    'Switch3Off': 'Switch #3 Off',
    'Switch4Off': 'Switch #4 Off',
    'AllSwitchOff': 'All Switch Off',
    'OpenSensor': 'Open Sensor',
    'Dorbell': 'Dorbell',
    'FireAlarm': 'Fire Alarm',
    'SecurityAlarm': 'Security Alarm',
    'TermalSensor': 'Termal Sensor',
    'MoveSensor': 'Move Sensor',
    'OtherSensor': 'Other Sensor'
  },
  'eventType': {
    'AccessCreated': 'Create access',
    'AccessSent': 'Access sent',
    'MqttMessageId': 'ACK Message',
    'ExternalServerMessageSendingTimeout': 'External service timeout',
    'ControllerWifiReconnection': 'WiFi connect',
    'ControllerMqttReconnection': 'MQTT connect',
    'SetControllerDescription': 'Update Controller info',
    'SetSwitchDescription': 'Switch settings update',
    'PendingAccessApproved': 'Access arrived to controller',
    'PendingAccessSaved': 'Access queued for sending',
    'RequestRegistration': 'Request registration',
    'AcceptRegistration': 'Accept registration',
    'DisableRegistration': 'Disable registration',
    'DeleteRegistration': 'Delete registration',
    'ActivateRegcode': 'Activate regcode',
    'ToggleSwitch': 'Toggle switch',
    'GetRegistrations': 'List keys',
    'GetRegistrationDetails': 'Key details',
    'GetLogEntries': 'List events',
    'GetDiagnosis': 'Show controller info',
    'SetControllerTime': 'Update controller time',
    'FailedSetControllerDescription': 'Failed Command r201',
    'FailedSetSwitchDescription': 'Failed Command r301',
    'FailedRequestRegistration': 'Failed Command r401',
    'FailedAcceptRegistration': 'Failed Command r501',
    'FailedDisableRegistration': 'Failed Command r601',
    'FailedDeleteRegistration': 'Failed Command r701',
    'FailedActivateRegcode': 'Failed Command r901',
    'FailedToggleSwitch': 'Toggle switch failed',
    'FailedGetRegistrations': 'Failed Command r111',
    'FailedGetRegistrationDetails': 'Failed Command r211',
    'FailedGetLogEntries': 'Failed Command r311',
    'FailedGetDiagnosis': 'Failed Command r411',
    'FailedSetControllerTime': 'Failed Command r511',
    'Switch1Toggle': 'Switch #1 Toggle',
    'Switch2Toggle': 'Switch #2 Toggle',
    'Switch3Toggle': 'Switch #3 Toggle',
    'Switch4Toggle': 'Switch #4 Toggle',
    'Switch1On': 'Switch #1 On',
    'Switch2On': 'Switch #2 On',
    'Switch3On': 'Switch #3 On',
    'Switch4On': 'Switch #4 On',
    'AllSwitchOn': 'All Switch On',
    'Switch1Off': 'Switch #1 Off',
    'Switch2Off': 'Switch #2 Off',
    'Switch3Off': 'Switch #3 Off',
    'Switch4Off': 'Switch #4 Off',
    'AllSwitchOff': 'All Switch Off',
    'OpenSensor': 'Open Sensor',
    'Dorbell': 'Dorbell',
    'FireAlarm': 'Fire Alarm',
    'SecurityAlarm': 'Security Alarm',
    'TermalSensor': 'Termal Sensor',
    'MoveSensor': 'Move Sensor',
    'OtherSensor': 'Other Sensor'
  },
  'event': {
    'toggle': {
      'type': {
        'bt': 'Mobile',
        'rfid': 'IDCard',
        'qr': 'QR'
      },
      'success': 'Accepted',
      'fail': 'Rejected',
      'fail-undefined': 'Undefined',
      'fail-disabled': 'Fail disabled',
      'fail-unregistered': 'Fail unregistered',
      'fail-out-of-interval': 'Fail unauthorized'
    }
  },
  'format': {
    'longDate': 'YYYY.MM.DD HH:mm:ss'
  },
  'remove.message': 'Do you really want to delete?',
  // ElementsUI Localization
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      year: '',
      month1: 'Jan',
      month2: 'Feb',
      month3: 'Mar',
      month4: 'Apr',
      month5: 'May',
      month6: 'Jun',
      month7: 'Jul',
      month8: 'Aug',
      month9: 'Sep',
      month10: 'Oct',
      month11: 'Nov',
      month12: 'Dec',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      placeholder: 'Select'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All'
    },
    tree: {
      emptyText: 'No Data'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en_us.js